<template>
	<section class="small-12 content flex justify-center animated fadeIn" v-if="article">
        <div class="small-12 large-6 columns">
            <article class="small-12" v-for="(section, index) in article.attributes.paragraphs" :key="index">
                <div class="small-12 sectionTitle" v-if="section.title">
                    <h2>{{section.title}}</h2>
                </div>
                <div class="small-12 sectionContent flex">
                    <p class="small-12" v-html="section.p" v-if="section.p"></p>
                    <div class="small-12 sectionButton flex" v-if="section.button">
                        <a :href="section.button.url" target="_blank" rel="nofollow noopener" class="bgPrimaryBlue borderRadius2">
                            {{ section.button.text }}
                        </a>
                    </div>
                    <figure class="float-left small-12 articleHR flex justify-center" v-if="section.hr"></figure>
                </div>
            </article>
        </div>
    </section>
</template>

<script>
	
	export default {

		/*
		** Set the component name
		*/

		name: 'AccessibilityContent',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			//

		],

		/*
		**  Set the props
		*/

		props: {

			article: {
                type: Object,
                default: () => null
            }

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			//

		}),

		/*
		**  Watch em'
		*/

		watch: {

			//

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			//

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>